module.exports = __webpack_public_path__ + "img/c279a3a.jpg";